import {
    CREATE_IRONING_PACKING_DC_FAILURE_DK,
    CREATE_IRONING_PACKING_DC_REQUEST_DK,
    CREATE_IRONING_PACKING_DC_SUCCESS_DK,
    CREATE_USER_FORM_IRONING_PACKING_DC_DK,
    FETCH_SINGLE_IRONING_PACKING_DC_FAILURE_DK,
    FETCH_SINGLE_IRONING_PACKING_DC_REQUEST_DK,
    FETCH_SINGLE_IRONING_PACKING_DC_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_FAILURE_DK,
    FETCH_IRONING_PACKING_DC_REQUEST_DK,
    FETCH_IRONING_PACKING_DC_SUCCESS_DK,
    NAVIGATE_IRONING_PACKING_DC_DETAILS_DK,
    NAVIGATE_IRONING_PACKING_DC_DK,
    IRONING_PACKING_DC_USERFORM_RESET_DK,
    UPDATE_IRONING_PACKING_DC_FAILURE_DK,
    UPDATE_IRONING_PACKING_DC_REQUEST_DK,
    UPDATE_IRONING_PACKING_DC_SUCCESS_DK,
    DELETE_IRONING_PACKING_DC_REQUEST_DK,
    DELETE_IRONING_PACKING_DC_SUCCESS_DK,
    DELETE_IRONING_PACKING_DC_FAILURE_DK,
    IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_IRONING_PACKING_DC_STYLE_REQUEST_DK,
    FETCH_IRONING_PACKING_DC_STYLE_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_STYLE_FAILURE_DK,
    FETCH_IRONING_PACKING_DC_INVOICE_REQUEST_DK,
    FETCH_IRONING_PACKING_DC_INVOICE_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_INVOICE_FAILURE_DK,
    RESET_IRONING_PACKING_DC_INVOICE_DK,
    RESET_PRINT_DATA_FOR_EDIT_IRONING_PACKING_DC,
    FETCH_IRONING_PACKING_DC_LIST_REQUEST_DK,
    FETCH_IRONING_PACKING_DC_LIST_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_LIST_FAILURE_DK

} from './ironingPackingDC.actionsType';

export const IRONING_PACKING_DC_DK = 'ironingPackingDcDK';

let initialState = {
    loading: false,
    ironingPackingDC: [],
    ironingPackingDCInvoice: [],
    ironingPackingDCStyle: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedIroningPackingDC: {},
    detailsId: '',
    activeKey: 1,
    isIroningPackingDC: false,
    ironingPackingDCSelectedValue: null,
    errorMessage: '',
    ironingPackingGridData: [],
    iperrorMessage: ''
};

export let ironingPackingDcDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_IRONING_PACKING_DC_REQUEST_DK:
        case FETCH_IRONING_PACKING_DC_INVOICE_REQUEST_DK:
        case FETCH_IRONING_PACKING_DC_STYLE_REQUEST_DK:
        case CREATE_IRONING_PACKING_DC_REQUEST_DK:
        case FETCH_SINGLE_IRONING_PACKING_DC_REQUEST_DK:
        case UPDATE_IRONING_PACKING_DC_REQUEST_DK:
        case DELETE_IRONING_PACKING_DC_REQUEST_DK:
        case FETCH_IRONING_PACKING_DC_LIST_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_IRONING_PACKING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingDC: updatePayload
            };
        case FETCH_IRONING_PACKING_DC_INVOICE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingDCInvoice: updatePayload
            };
        case FETCH_IRONING_PACKING_DC_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingDCStyle: updatePayload?.PONO
            };
        case CREATE_IRONING_PACKING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_IRONING_PACKING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedIroningPackingDC: updatePayload,
                userform: updatePayload
            };
        case FETCH_IRONING_PACKING_DC_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingGridData: updatePayload
            };

        case RESET_PRINT_DATA_FOR_EDIT_IRONING_PACKING_DC:
            return {
                ...state,
                loading: false,
                ironingPackingGridData: []
            };
        case UPDATE_IRONING_PACKING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedIroningPackingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_IRONING_PACKING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedIroningPackingDC: {}
            };
        case FETCH_IRONING_PACKING_DC_FAILURE_DK:
        case FETCH_IRONING_PACKING_DC_INVOICE_FAILURE_DK:
        case FETCH_IRONING_PACKING_DC_STYLE_FAILURE_DK:
        case FETCH_SINGLE_IRONING_PACKING_DC_FAILURE_DK:
        case CREATE_IRONING_PACKING_DC_FAILURE_DK:
        case UPDATE_IRONING_PACKING_DC_FAILURE_DK:
        case DELETE_IRONING_PACKING_DC_FAILURE_DK:
        case FETCH_IRONING_PACKING_DC_LIST_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_IRONING_PACKING_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_IRONING_PACKING_DC_INVOICE_DK:
            return {
                ...state,
                ironingPackingDCInvoice: []
            };
        case IRONING_PACKING_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                selectedIroningPackingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_IRONING_PACKING_DC_DETAILS_DK:
            return {
                ...state,
                isIroningPackingDC: true,
                ironingPackingDCSelectedValue: updatePayload.ironingPackingDCSelectedValue
            };
        case NAVIGATE_IRONING_PACKING_DC_DK:
            return {
                ...state,
                isIroningPackingDC: false
            };
        case IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
